import { render } from "./PrintFooterDesign1.vue?vue&type=template&id=4a51941d&scoped=true"
import script from "./PrintFooterDesign1.vue?vue&type=script&lang=js"
export * from "./PrintFooterDesign1.vue?vue&type=script&lang=js"

import "./PrintFooterDesign1.vue?vue&type=style&index=0&id=4a51941d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a51941d"]])

export default __exports__